import Vue from 'vue';
import Router from 'vue-router';
import store from '@/plugins/store';
import publicRoutes from '@/routes/public';
import privateRoutes from '@/routes/private';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: publicRoutes.concat(privateRoutes),
});

router.beforeEach((to, from, next) => {
  store.commit('USERS_INIT');

  if (from.matched.some((record) => record.meta.onlyLoggedOut)) {
    next();
    return;
  }

  const { authenticated } = store.state.users;
  const onlyLoggedOut = to.matched.some((record) => record.meta.onlyLoggedOut);
  const isPublic = to.matched.some((record) => record.meta.public);
  if (!isPublic && !authenticated) {
    next({
      path: '/login',
    });
    store.commit('set_app_section', '');
    return;
  }
  if (authenticated && onlyLoggedOut) {
    next('/');
    return;
  }
  next();
});

export default router;
